/* eslint-disable */
export default {
    Search: {
        btns: {
            protein: 'Protein',
            nucleotide: 'Nucleotides',
            nucleotideDb: 'Nucleotides database',
            proteinDb: 'Protein database',
            upload: 'Upload Sequence',
            delete: 'Delete',
            clear: 'Clear',
            addFragment: 'Add Fragment',
        },
        propver: {
            reset: 'reset',
            Preferences: {
                qconv: {
                    1: 'The higher you push this coverage %, the more similar sequences you receive.',
                    2: 'Use query coverage to determine the minimum % of your sequence that must be aligned to a result sequence. If the entire sequence is important, consider using a high percentage.',
                },
                gaps: {
                    1: 'ギャップ入れマッチングでは、配列アラインメントのBLASTスコアを変更するだけであり、回答される結果を必ずしも増加したり減少させるわけではありません。',
                    2: 'ギャップを入れてマッチングするかどうかの設定は、配列アラインメントの結果にギャップを含めるかどうかを決定します。配列内の一部のセグメントが非常に類似しているが、いくつかの不一致部分で分離されている場合は、ギャップ入れマッチングをオンにすることをお勧めします:',
                    3: '特許は、ギャップを入れるか問わず、特定の百分率内の配列を保護することができるため、２モードとも試す価値があります。',
                },
                evalue: {
                    1: 'E-Valueの期待閾値が高いほど、より多くの結果が回答される可能性があります。',
                    2: 'E-Valueは、ヒットした配列が偶然にクエリ配列に類似している確率を表します。たとえば、クエリ配列が非常に短い場合、配列内の異なる位置に偶然に位置する可能性が高くなります。 E-Valueが高く設定されているほど、偶然性が大きくなります。',
                },
                algorithm: {
                    megaBlast: '非常に類似した配列を比較するのに適しています。',
                    blastn: '標準的なヌクレオチド検索。ヌクレオチド配列をデータベースと比較します。',
                    blastnShort: '長さが50ヌクレオチドより短い配列に適しています。',
                    blastxFast: 'リエリしようとするヌクレオチド配列をタンパク質配列に翻訳し、これに類似したものをデータベースから検索します。',
                    blastpFast: '比較的に長いワードを用います。標準的なBlastpよりも短い時間がかかります。',
                    blastp: '標準的タンパク質検索。タンパク質ライブラリからタンパク質配列をマッチングします。',
                    blastpShort: '長さが50ヌクレオチドより短い配列に適しています。',
                    tblastnFast: 'リエリしようとするヌクレオチド配列をタンパク質配列に翻訳し、これに類似したものをデータベースから検索します。',
                },
                lowComplexRegion: 'クエリ配列の中の低複雑度の領域をブロックします。',
                defaultAlgorithm: '短いシーケンスを入力すると、アルゴリズムはブラストショートに調整する。',
                slowWarning: '検索は、タンパク質配列によるヌクレオチドデータベースに対してより長いかもしれません！',
                algorithmDescription: {
                    1:
                      '<b>Global alignment algorithm</b> (such as Needleman-Wunsch) aligns two ' +
                      'sequences from beginning to end, aligning each letter in each sequence only ' +
                      'once. An alignment is produced, regardless of whether or not there is similarity ' +
                      'between the sequences.',
                    2:
                      '<b>Local alignment algorithm</b> (such as BLAST) can also be used to align two ' +
                      'sequences, but will only align those portions of the sequences that share ' +
                      'similarity. If there is no similarity, no alignment will be returned.',
                    3:
                      'Global alignment algorithm should only be used on sequences that share significant similarity over most of their extents, and then it will sometimes return a better presentation, especially for short sequences.',
                },
            },
        },
        labels: {
            refinements: 'PREFERENCES',
            predicted: '配列タイプ:',
            database: 'Search within:',
            advance: 'Advanced Preferences >',
            sequenceLength: 'Sequence Length',
            preferences: 'Preferences',
            countries: 'Countries',
            countriesTitle: 'Choose Jurisdictions',
            similarity: '目標配列長さ (%)',
            qconv: 'クエリカバレッジ (%) ',
            gaps: 'ギャップ入れマッチング',
            evalue: 'E-Value',
            algorithm: 'アルゴリズム',
            matrix: 'スコアマトリックス',
            wordSize: 'ワードサイズ',
            wordSizeHold: 'デフォルト',
            gapCosts: 'ギャップペナルティ',
            matchScores: '一致スコア/不一致ペナルティ',
            matchScoresNoWrap: '一致スコア/不一致ペナルティ',
            proAutoAdjust:
                'Automatically adjust parameters for short input sequences. If selected, blastp-short will be used for sequences with 30 or fewer amino acids.',
            nuAutoAdjust:
                'Automatically adjust parameters for short input sequences. If selected, blastn-short will be used for sequences with fewer than 50 nucleotides.',
            threshold: '期待閾値',
            yes: 'はい',
            no: 'いいえ',
            queryIdentity: 'クエリ類似度 (%)',
            subjectIdentity: '目標類似度 (%)',
            subjectCoverage: '目標範囲 (%)',
            subjectLength: '目標配列長さ',
            subjectProteinLength: '目標配列長さ（aa）',
            subjectNucLength: '目標配列長さ（nt）',
            targetSeqLimit: 'Max Target Sequence',
            targetSeqLimitTooltip: 'Please contact customer service to upgrade your permissions.',
            length: 'Length',
            multi: 'Multi',
            lowComplexRegion: '無視する低複雑度領域',
            defaultAlgorithm: 'デフォルトアルゴリズム',
            searchParameters: '検索パラメータ',
            algorithmSettings: 'Algorithm settings',
            databaseTitle: 'データベース',
            mismatch: 'ミスマッチ',
            algorithmType: 'Search Algorithm',
            alignmentIdentity: 'Alignment Identity (%)',
            gapExtend: 'Gap Extent',
            gapOpen: 'Gap Open',
            scoreMatrix: 'Substitution Matrix',
            algorithmTypes: {
                Blast: 'Blast Search',
                Nw: 'Global Alignment Search',
            },
            nonShortSequence: 'Non-Short Sequences',
            shortSequence: 'Short Sequences',
        },
        explanation: {
            example: 'Example',
            identityLength: 'Identity Length',
            alignLength: 'Align Length',
            queryLength: 'Query Length',
            subjectLength: '目標配列長さ',
        },
    },
};
